<template>
  <a-modal v-model:visible="visible" title="凭证" @ok="handleOk" centered :footer="null">
    <div v-if="evidenceData?.proofUrls?.length">
      <div class="label">
        <span>凭证：</span>
        <a-image-preview-group>
          <auth-img
            mode="ant"
            v-for="(it, index) in evidenceData.proofUrls"
            :key="index"
            :width="80"
            :src="it"
          />
        </a-image-preview-group>
      </div>
    </div>
    <div class="label" v-if="evidenceData.remark">
      <span>补充说明：</span>
      {{ evidenceData.remark }}
    </div>
  </a-modal>
</template>
<script setup>
import { ref, defineExpose, reactive } from 'vue'
const visible = ref(false)
const evidenceData = reactive({
  proofUrls: [],
  remark: ''
})
const initModal = item => {
  visible.value = true
  const { proofUrls, remark } = item
  evidenceData.proofUrls = proofUrls
  evidenceData.remark = remark
}
const handleOk = () => {
  visible.value = false
}
defineExpose({ initModal })
</script>
<style scoped lang="scss">
.label {
  display: flex;

  margin-bottom: 30px;
  ::v-deep(.ant-image) {
    margin-right: 10px;
    cursor: pointer;
  }
  span {
    width: 80px;
    text-align-last: justify;
    margin-right: 10px;
    flex-shrink: 0;
  }
}
</style>
